import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { UserRole, UserRoleAll } from '../models/user';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard {
  private authService = inject(AuthService);
  private router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const allowedRoles: UserRole[] = route.data.allowedRoles ?? UserRoleAll;
    if (allowedRoles?.includes(this.authService.user.role)) {
      return true;
    }
    // CRAT-975 — a Lister has no orders access, so the default /orders fallback would loop. Send
    // them to their landing (the add-new-item search page).
    if (this.authService.user.role === UserRole.lister) {
      return this.router.navigate(['/inventory/search-products']);
    }
    return this.router.navigate(['/orders']);
  }
}
